'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Element = require("rescript-webapi/lib/js/src/Webapi/Dom/Webapi__Dom__Element.js");
var Image$PvpcontrollerWeb = require("./Image.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");

var entityColor = Css.hex("323437");

var entityHeight = Css.px(30);

var label = Curry._1(Css.style, {
      hd: Css.marginBottom(Css.px(10)),
      tl: /* [] */0
    });

var error = Curry._1(Css.style, {
      hd: Css.color(Css.red),
      tl: {
        hd: Css.height(Css.px(21)),
        tl: /* [] */0
      }
    });

var entitiesContainer = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexWrap("wrap"),
        tl: /* [] */0
      }
    });

var entity = Curry._1(Css.style, {
      hd: Css.background(entityColor),
      tl: {
        hd: Css.padding2(Css.px(5), Css.px(10)),
        tl: {
          hd: Css.borderRadius(Css.px(5)),
          tl: {
            hd: Css.margin2(Css.px(5), Css.px(5)),
            tl: {
              hd: Css.display("flex"),
              tl: {
                hd: Css.alignItems(Css.center),
                tl: {
                  hd: Css.color(Theme$PvpcontrollerWeb.textColor),
                  tl: {
                    hd: Css.height(entityHeight),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var entityAdd = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.background(entityColor),
        tl: {
          hd: Css.padding2(Css.px(5), Css.px(5)),
          tl: {
            hd: Css.borderRadius(Css.px(999)),
            tl: {
              hd: Css.alignItems(Css.center),
              tl: {
                hd: Css.color(Theme$PvpcontrollerWeb.textColor),
                tl: {
                  hd: Css.cursor(Css.pointer),
                  tl: {
                    hd: Css.margin2(Css.px(5), Css.px(5)),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var entityRemove = Curry._1(Css.style, {
      hd: Css.borderRadius(Css.px(999)),
      tl: {
        hd: Css.textAlign(Css.center),
        tl: {
          hd: Css.marginLeft(Css.px(5)),
          tl: {
            hd: Css.cursor(Css.pointer),
            tl: /* [] */0
          }
        }
      }
    });

var input = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.textColor),
      tl: /* [] */0
    });

var entityImage = Curry._1(Css.style, {
      hd: Css.marginRight(Css.px(10)),
      tl: {
        hd: Css.maxHeight(entityHeight),
        tl: /* [] */0
      }
    });

var entityText = Curry._1(Css.style, {
      hd: Css.position(Css.relative),
      tl: {
        hd: Css.bottom(Css.px(1)),
        tl: /* [] */0
      }
    });

function onNewValue(param, extractStateObject, applyToStateObject, parseString, setValueState, $$event) {
  var value = $$event.target.value;
  $$event.target.value = "";
  var value$1 = Curry._1(parseString, value);
  var match = Curry._1(extractStateObject, param[0]);
  if (match === undefined) {
    return ;
  }
  if (value$1 === undefined) {
    return ;
  }
  var object = Caml_option.valFromOption(match);
  Curry._1(setValueState, (function (_previousState) {
          return {
                  TAG: /* WaitingAddEntity */0,
                  _0: value$1
                };
        }));
  return Curry._1(param[1], (function (_previousState) {
                return Curry._2(applyToStateObject, object, value$1);
              }));
}

function onRemoveEntity(param, extractStateObject, applyToStateObject, setValueState, value, _event) {
  var object = Curry._1(extractStateObject, param[0]);
  if (object === undefined) {
    return ;
  }
  var object$1 = Caml_option.valFromOption(object);
  Curry._1(setValueState, (function (_previousState) {
          return {
                  TAG: /* WaitingRemoveEntity */2,
                  _0: value
                };
        }));
  return Curry._1(param[1], (function (_previousState) {
                return Curry._2(applyToStateObject, object$1, value);
              }));
}

function onKeyPress($$event) {
  var key = $$event.key;
  if (key !== "Enter") {
    return ;
  }
  var target = $$event.target;
  return Belt_Option.mapWithDefault(Webapi__Dom__Element.asHtmlElement(target), undefined, (function (prim) {
                prim.blur();
                
              }));
}

function EntityList(Props) {
  var entities = Props.entities;
  var label$1 = Props.label;
  var editMode = Props.editMode;
  var onChange = Props.onChange;
  var insertValue = Props.insertValue;
  var removeValue = Props.removeValue;
  var session = Props.session;
  var entityToString = Props.entityToString;
  var removeEntity = Props.removeEntity;
  var onEntityListUpdated = Props.onEntityListUpdated;
  var entityToImage = Props.entityToImage;
  var match = React.useState(function () {
        return /* Normal */0;
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (typeof session !== "object") {
            return ;
          }
          if (session.NAME !== "Verified") {
            return ;
          }
          if (typeof state === "number") {
            return ;
          }
          switch (state.TAG | 0) {
            case /* WaitingAddEntity */0 :
                var value = state._0;
                return Curry._3(insertValue, session, value, (function (result) {
                              if (result.TAG === /* Ok */0 && result._0.status === 200) {
                                Curry._1(setState, (function (_previousState) {
                                        return /* Normal */0;
                                      }));
                                return Curry._1(onEntityListUpdated, undefined);
                              }
                              return Curry._1(setState, (function (_previousState) {
                                            return {
                                                    TAG: /* FailedToAddEntity */1,
                                                    _0: value
                                                  };
                                          }));
                            }));
            case /* WaitingRemoveEntity */2 :
                var value$1 = state._0;
                return Curry._3(removeValue, session, value$1, (function (result) {
                              if (result.TAG === /* Ok */0 && result._0.status === 200) {
                                Curry._1(setState, (function (_previousState) {
                                        return /* Normal */0;
                                      }));
                                return Curry._1(onEntityListUpdated, undefined);
                              }
                              return Curry._1(setState, (function (_previousState) {
                                            return {
                                                    TAG: /* FailedToRemoveEntity */3,
                                                    _0: value$1
                                                  };
                                          }));
                            }));
            default:
              return ;
          }
        }), [state]);
  var tmp;
  if (editMode !== 1) {
    tmp = React.createElement(React.Fragment, undefined);
  } else {
    var exit = 0;
    if (typeof state === "number") {
      tmp = state === /* Normal */0 ? React.createElement("div", {
              className: entityAdd,
              onClick: (function (_event) {
                  return Curry._1(setState, (function (_previousState) {
                                return /* AddingEntity */1;
                              }));
                })
            }, React.createElement("i", {
                  className: "fas fa-plus"
                })) : React.createElement("div", {
              className: entity
            }, React.createElement("input", {
                  defaultValue: "",
                  className: input,
                  style: {
                    borderBottom: "none"
                  },
                  autoFocus: true,
                  type: "text",
                  onKeyPress: onKeyPress,
                  onBlur: Curry._1(onChange, setState)
                }));
    } else {
      switch (state.TAG | 0) {
        case /* FailedToAddEntity */1 :
            var value = state._0;
            tmp = React.createElement("i", {
                  className: "fas fa-exclamation-circle " + error,
                  title: "Update failed. Click to try again.",
                  onClick: (function (_event) {
                      return Curry._1(setState, (function (_previousState) {
                                    return {
                                            TAG: /* WaitingAddEntity */0,
                                            _0: value
                                          };
                                  }));
                    })
                });
            break;
        case /* WaitingAddEntity */0 :
        case /* WaitingRemoveEntity */2 :
            exit = 1;
            break;
        case /* FailedToRemoveEntity */3 :
            var value$1 = state._0;
            tmp = React.createElement("i", {
                  className: "fas fa-exclamation-circle " + error,
                  title: "Update failed. Click to try again.",
                  onClick: (function (_event) {
                      return Curry._1(setState, (function (_previousState) {
                                    return {
                                            TAG: /* WaitingRemoveEntity */2,
                                            _0: value$1
                                          };
                                  }));
                    })
                });
            break;
        
      }
    }
    if (exit === 1) {
      tmp = React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps({
                height: "10px",
                margin: "13px 0",
                width: "10px",
                flexShrink: "0"
              }, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
    }
    
  }
  return React.createElement("div", undefined, React.createElement("div", {
                  className: Theme$PvpcontrollerWeb.label + " " + label
                }, label$1), React.createElement("div", {
                  className: entitiesContainer
                }, Belt_Array.mapWithIndex(entities, (function (i, entity$1) {
                        return React.createElement("div", {
                                    key: String(i),
                                    className: entity
                                  }, entityToImage !== undefined ? React.createElement(Image$PvpcontrollerWeb.make, Image$PvpcontrollerWeb.makeProps(Curry._1(entityToImage, entity$1), entityImage, undefined, undefined, undefined, undefined)) : React.createElement(React.Fragment, undefined), React.createElement("div", {
                                        className: entityText
                                      }, Curry._1(entityToString, entity$1)), editMode !== 1 ? React.createElement(React.Fragment, undefined) : React.createElement("i", {
                                          className: entityRemove + " fas fa-times",
                                          onClick: Curry._2(removeEntity, setState, entity$1)
                                        }));
                      })), tmp));
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9, prim10, prim11, prim12) {
  var tmp = {
    entities: prim0,
    label: prim1,
    editMode: prim2,
    onChange: prim3,
    insertValue: prim4,
    removeValue: prim5,
    session: prim6,
    entityToString: prim7,
    removeEntity: prim8,
    onEntityListUpdated: prim9
  };
  if (prim10 !== undefined) {
    tmp.entityToImage = Caml_option.valFromOption(prim10);
  }
  if (prim11 !== undefined) {
    tmp.key = prim11;
  }
  return tmp;
}

var make = EntityList;

exports.onNewValue = onNewValue;
exports.onRemoveEntity = onRemoveEntity;
exports.makeProps = makeProps;
exports.make = make;
/* entityColor Not a pure module */
